/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { paginationLinks } from '../models/paginationLinks'
import type { paginationMeta } from '../models/paginationMeta'
import type { PermissionFormatQuery } from '../models/PermissionFormatQuery'
import type { RoleResource } from '../models/RoleResource'
import type { RoleWrite } from '../models/RoleWrite'

import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'

export class UsersRolesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * List Roles.
     * @returns any OK
     * @throws ApiError
     */
    public listRoles({
        page
    }: {
        /**
         * The page to retrieve starting with page 1.
         */
        page?: number
    }): CancelablePromise<{
        data: Array<RoleResource>
        meta: paginationMeta
        links: paginationLinks
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/roles',
            query: {
                page: page
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * Create a role.
     * Name must be unique.
     * @returns any Created
     * @throws ApiError
     */
    public createRole({ requestBody }: { requestBody: RoleWrite }): CancelablePromise<{
        data: RoleResource
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/roles',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * Show a single Role.
     * @returns any OK
     * @throws ApiError
     */
    public showRole({
        id
    }: {
        /**
         * ID of the retrieved resource.
         */
        id: number
    }): CancelablePromise<{
        data: RoleResource
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/roles/{id}',
            path: {
                id: id
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }

    /**
     * Delete a Role.
     * @returns void
     * @throws ApiError
     */
    public deleteRole({
        id
    }: {
        /**
         * ID of the retrieved resource.
         */
        id: number
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/roles/{id}',
            path: {
                id: id
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }

    /**
     * Update Role.
     * @returns any OK
     * @throws ApiError
     */
    public updateRole({
        id,
        requestBody,
        format
    }: {
        /**
         * ID of the retrieved resource.
         */
        id: number
        requestBody: RoleWrite
        format?: PermissionFormatQuery
    }): CancelablePromise<{
        data: RoleResource
    }> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/roles/{id}',
            path: {
                id: id
            },
            query: {
                format: format
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }
}
